export function normalizeBackgroundImageValue(value) {
  const nextValue = String(value || '').trim();
  if (!nextValue || nextValue.toLowerCase() === 'none') {
    return nextValue;
  }
  if (/^url\s*\(/i.test(nextValue)) {
    return nextValue;
  }
  const unquoted = nextValue.replace(/^["']|["']$/g, '');
  return `url("${unquoted}")`;
}

export function extractUrlFromBackgroundImage(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const match = raw.match(/url\s*\(\s*['"]?([^'")]+)['"]?\s*\)/i);
  if (match) return match[1].trim();
  if (/^https?:\/\//i.test(raw) || raw.startsWith('/')) return raw;
  if (raw.startsWith('data:')) return raw;
  return '';
}

export function isDataUrl(value) {
  return /^data:image\//i.test(String(value || '').trim());
}
